import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "magnifier",
  "use": "magnifier-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"magnifier\">\n    <g fill-rule=\"evenodd\">\n        <path d=\"M10.667 4c3.682 0 6.666 2.985 6.666 6.667 0 1.6-.564 3.07-1.505 4.22l4.496 4.494-.943.943-4.495-4.496c-1.149.94-2.618 1.505-4.22 1.505C6.986 17.333 4 14.35 4 10.667 4 6.985 6.985 4 10.667 4zm0 1.333c-2.946 0-5.334 2.388-5.334 5.334 0 2.945 2.388 5.333 5.334 5.333C13.612 16 16 13.612 16 10.667c0-2.946-2.388-5.334-5.333-5.334z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol